// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gerar-container {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 30px;
  margin-bottom: 30px;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: 600;
  color: #666;
}

.info-value {
  font-weight: 500;
  color: #333;
}

.warning-box {
  background: #fff3cd;
  color: #856404;
  padding: 15px;
  border-radius: 4px;
  margin-top: 15px;
  text-align: center;
}

.atletas-list {
  max-height: 300px;
  overflow-y: auto;
  margin-top: 15px;
}

.atleta-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #eee;
}

.atleta-item:last-child {
  border-bottom: none;
}

.atleta-nome {
  flex: 1 1;
  color: #333;
}

.atleta-faixa {
  background: #f5f5f5;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  color: #666;
}

.regras {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 15px;
}

.regra-item {
  padding: 15px;
  background: #f9f9f9;
  border-radius: 4px;
  border-left: 4px solid #2196F3;
}

.regra-item strong {
  color: #2196F3;
  margin-right: 8px;
}

@media (max-width: 768px) {
  .gerar-container {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/GerarChaves.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".gerar-container {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 30px;\n  margin-bottom: 30px;\n}\n\n.form-section {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.info-section {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.info-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.info-item:last-child {\n  border-bottom: none;\n}\n\n.info-label {\n  font-weight: 600;\n  color: #666;\n}\n\n.info-value {\n  font-weight: 500;\n  color: #333;\n}\n\n.warning-box {\n  background: #fff3cd;\n  color: #856404;\n  padding: 15px;\n  border-radius: 4px;\n  margin-top: 15px;\n  text-align: center;\n}\n\n.atletas-list {\n  max-height: 300px;\n  overflow-y: auto;\n  margin-top: 15px;\n}\n\n.atleta-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n.atleta-item:last-child {\n  border-bottom: none;\n}\n\n.atleta-nome {\n  flex: 1;\n  color: #333;\n}\n\n.atleta-faixa {\n  background: #f5f5f5;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #666;\n}\n\n.regras {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  margin-top: 15px;\n}\n\n.regra-item {\n  padding: 15px;\n  background: #f9f9f9;\n  border-radius: 4px;\n  border-left: 4px solid #2196F3;\n}\n\n.regra-item strong {\n  color: #2196F3;\n  margin-right: 8px;\n}\n\n@media (max-width: 768px) {\n  .gerar-container {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
